"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startsWithCapital = exports.isSnakeCase = exports.uuidToHex = exports.hexToUuid = exports.isUuid = exports.isHexUuid = void 0;
const util_1 = require("@polkadot/util");
const internal_1 = require("../internal");
const types_1 = require("../types");
const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const hexUuidRegex = /^(0x)?([0-9a-f]{32})$/i;
/**
 * @returns true if input is 32 byte hex encoded string (0x prefix optional)
 */
const isHexUuid = (input) => {
    return hexUuidRegex.test(input);
};
exports.isHexUuid = isHexUuid;
/**
 * @returns true if input is formatted as a UUID e.g. `12341234-1234-1234-1234-123412341234`
 */
const isUuid = (uuid) => {
    return uuidRegex.test(uuid);
};
exports.isUuid = isUuid;
/**
 * @hidden
 *
 * converts a 32 character hex string into a UUID format e.g `12341234-1234-1234-1234-123412341234`
 */
const hexToUuid = (input) => {
    const rawHex = (0, util_1.hexStripPrefix)(input.trim());
    if (!(0, exports.isHexUuid)(rawHex)) {
        throw new internal_1.PolymeshError({
            message: 'hex encoded UUID should have 32 hex characters (16 bytes)',
            code: types_1.ErrorCode.ValidationError,
            data: { input },
        });
    }
    const uuid = [
        rawHex.slice(0, 8),
        rawHex.slice(8, 12),
        rawHex.slice(12, 16),
        rawHex.slice(16, 20),
        rawHex.slice(20),
    ].join('-');
    return uuid;
};
exports.hexToUuid = hexToUuid;
/**
 * @hidden
 *
 * converts a UUID into a 32 character, 0x prefixed, hex string e.g. `0x12341234123412341234123412341234`
 */
const uuidToHex = (uuid) => {
    const trimmedUuid = uuid.trim();
    if (!(0, exports.isUuid)(trimmedUuid)) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.ValidationError,
            message: 'non uuid cannot be transformed to hex',
            data: { uuid },
        });
    }
    return `0x${trimmedUuid.replace(/-/g, '')}`;
};
exports.uuidToHex = uuidToHex;
const isSnakeCase = (input) => {
    return /^[a-z][a-z0-9]*(?:_[a-z0-9]+)*$/.test(input);
};
exports.isSnakeCase = isSnakeCase;
const startsWithCapital = (input) => {
    return input[0] === input[0].toUpperCase();
};
exports.startsWithCapital = startsWithCapital;
//# sourceMappingURL=strings.js.map